import React from 'react';
import { connect } from 'react-redux';
import { setCarPriceList } from '../Actions/CarPriceLists.action';
import PriceModelSelector from '../Components/PriceModelSelector';
import { searchFacetUpdate, searchFacetRefresh } from '../Actions/FacetedSearch.action';


const PriceModelSelectorContainer = (props) => {
    const setPriceListAndUpdate = (priceList) => {
        props.setCarPriceList(priceList).then(() => props.searchFacetRefresh());
    }

    return (
        <PriceModelSelector
            carPriceLists={props.carPriceLists}
            setCarPriceList={setPriceListAndUpdate} />
    )
}

const mapStateToProps = state => {
    const { facetedSearch: { facetFilters } } = state;
    const { configurator: { carPriceLists } } = state;
    return {
        carPriceLists,
        facetFilters
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setCarPriceList: (priceList) => dispatch(setCarPriceList(priceList)),
        searchFacetUpdate: (group, item) => dispatch(searchFacetUpdate(group, item)),
        searchFacetRefresh: () => dispatch(searchFacetRefresh()),

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PriceModelSelectorContainer);


